import Image from 'next/image'
import styles from '@comp/home/home-experience.module.css'

const logos = [
  { src: '/images/logos/ziraat-bankasi-logo.svg', alt: 'Ziraat Bankası', width: 131, height: 29 },
  { src: '/images/logos/iga-istanbul-logo.svg', alt: 'IGA Istanbul Airport', width: 129, height: 21 },
  { src: '/images/logos/mcdonalds.svg', alt: "McDonald's", width: 43, height: 39 },
  { src: '/images/logos/stc.svg', alt: 'Saudi Telecom Company', width: 65, height: 33 },
  { src: '/images/logos/odeabank.svg', alt: 'Odeabank', width: 94, height: 19 },
  { src: '/images/logos/godiva-logo.svg', alt: 'Godiva', width: 54, height: 39 },
  { src: '/images/logos/united-biscuits.svg', alt: 'United Biscuits', width: 42, height: 35 },
  { src: '/images/logos/fener-logo.svg', alt: 'Fenerbahçe Sports Club', width: 44, height: 43 },
]

export default function CustomerLogos({ lang }: { lang: 'en' | 'tr' }) {
  return <section className={styles.trust} aria-label={lang === 'tr' ? 'Müşterilerimiz' : 'Our customers'}>
    <p>{lang === 'tr' ? 'Dünyanın önde gelen kurumlarının güveniyle' : 'Trusted by teams that keep the world moving'}</p>
    <div className={styles.logos}>{logos.map(logo => <Image key={logo.src} src={logo.src} alt={logo.alt} width={logo.width} height={logo.height} />)}</div>
  </section>
}
